"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.revolut = exports.revolutMatcher = exports.revolutParser = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var date_fns_1 = require("date-fns");

var papaparse_1 = require("../../util/papaparse");

var COMPLETED_DATE = 0;
var REFERENCE = 1;
var PAID_OUT = 2;
var PAID_IN = 3;
var CATEGORY = 8;

exports.generateYnabDate = function (input) {
  var match = date_fns_1.parse(input, 'dd MMM', Date.now());

  if (!isValidDate(match)) {
    match = date_fns_1.parse(input, 'dd MMM yyyy', Date.now());
  }

  return date_fns_1.format(match, 'yyyy-MM-dd');
};

exports.revolutParser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            header: false
          })];

        case 1:
          data = _a.sent().data;
          return [2
          /*return*/
          , [{
            data: data.slice(1).filter(function (r) {
              return r[0];
            }).map(function (r) {
              return {
                Date: exports.generateYnabDate(r[COMPLETED_DATE]),
                Payee: r[REFERENCE].trim(),
                Category: r[CATEGORY].trim(),
                Memo: r[REFERENCE].trim(),
                Outflow: r[PAID_OUT].trim() ? Number(r[PAID_OUT]).toFixed(2) : undefined,
                Inflow: r[PAID_IN].trim() ? Number(r[PAID_IN]).toFixed(2) : undefined
              };
            })
          }]];
      }
    });
  });
};

exports.revolutMatcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var requiredKeys, data, csvColumnNames;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          requiredKeys = ['Completed Date', 'Reference', 'Exchange Rate', 'Category'];
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            preview: 1
          })];

        case 1:
          data = _a.sent().data;

          if (data.length === 0) {
            return [2
            /*return*/
            , false];
          }

          csvColumnNames = data[0].map(function (r) {
            return r.trim();
          });
          return [2
          /*return*/
          , requiredKeys.every(function (key) {
            return csvColumnNames.includes(key);
          })];
      }
    });
  });
};

exports.revolut = {
  name: 'Revolut',
  country: 'international',
  fileExtension: 'csv',
  filenamePattern: /^Revolut-(.+)-Statement-(.+)\.csv$/,
  link: 'https://blog.revolut.com/new-feature-exportable-statements/',
  match: exports.revolutMatcher,
  parse: exports.revolutParser
};

var isValidDate = function isValidDate(date) {
  return !isNaN(date.getTime());
};